import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApiService } from '@app/core/services/api/base-api/base-api.service';
import { API_CONSTANTS } from '@app/core/constants/api.constants';
import { Observable } from 'rxjs';
import {
    ISupportRequestsResponse,
    ISupportRequest,
    SupportRequestStatus,
    SupportRequestPriority,
    IUserSupportRequest,
} from '../interfaces/support-request.interface';

/** Admin support ticket list and status updates. */
@Injectable({
    providedIn: 'root',
})
export class SupportApiService extends BaseApiService {
    constructor(http: HttpClient) {
        super(http, API_CONSTANTS.ENDPOINTS.SUPPORT);
    }

    /**
     * Lists support requests with optional filters and pagination.
     * @param filters - Search, status, and priority filters
     * @param limit - Page size (default 50)
     * @param skip - Offset for pagination
     */
    getAllSupportRequests(
        filters?: {
            search?: string;
            status?: SupportRequestStatus | 'all';
            priority?: SupportRequestPriority | 'all';
        },
        limit: number = 50,
        skip: number = 0
    ): Observable<ISupportRequestsResponse> {
        let params = new HttpParams();
        params = params.set('limit', limit.toString());
        params = params.set('skip', skip.toString());

        if (filters) {
            if (filters.search) {
                params = params.set('search', filters.search);
            }
            if (filters.status && filters.status !== 'all') {
                params = params.set('status', filters.status);
            }
            if (filters.priority && filters.priority !== 'all') {
                params = params.set('priority', filters.priority);
            }
        }

        return this.get<ISupportRequestsResponse>('', params);
    }

    /**
     * Creates a new support request.
     * @param data - User-submitted ticket payload
     */
    createSupportRequest(data: IUserSupportRequest): Observable<ISupportRequest> {
        return this.post<ISupportRequest>('', data);
    }

    /**
     * Updates the status of a support request.
     * @param uuid - Ticket id
     * @param status - New workflow status
     */
    updateSupportRequestStatus(uuid: string, status: SupportRequestStatus): Observable<ISupportRequest> {
        return this.patch<ISupportRequest>(`/${uuid}/status`, { status });
    }
}
